import React from 'react'
import { useTranslation } from 'react-i18next'
import { Label } from 'semantic-ui-react'

const CountriesOfOriginLabel = ({item}) => {
    const [t] = useTranslation()

    const countriesOfOriginArray =
      item.inventory?.countriesOfOrigin.length > 0 ?
        item.inventory?.countriesOfOrigin :
        item.countriesOfOrigin?.length > 0 ?
          item.countriesOfOrigin :
          []

    const countriesOfOriginLabel = countriesOfOriginArray.length > 0 ?
      countriesOfOriginArray.join(', ') :
      null

    if (!countriesOfOriginLabel) {
        return null
    }

    return (
      <Label>{`${t('item_edit.countries_of_origin', { count: countriesOfOriginArray.length })} : ${countriesOfOriginLabel}`}</Label>
    )
}

export { CountriesOfOriginLabel }
